import { useRef } from "react";
import { ArrowLeft2, ArrowRight2 } from "iconsax-reactjs";
import VideoCarouselItem from "./VideoCarouselItem";
import VideoCarouselItemSkeleton from "./VideoCarouselItemSkeleton";
import Button from "../../commons/Button";
import type { Video } from "../../../services/webServices/video/types";

type VideoCarouselProps = {
  video: Video[];
  isLoading: boolean;
  onEdit: (video: Video) => void;
  onDelete: (uuid: string) => void;
};

export default function VideoCarousel({ video, onEdit, isLoading, onDelete }: VideoCarouselProps) {

  const scrollRef = useRef<HTMLDivElement | null>(null);

  const scroll = (dir: "left" | "right") => {
    const amount = dir === "left" ? -300 : 300;
    scrollRef.current?.scrollBy({ left: amount, behavior: "smooth" });
  };

  return (
    <div className="relative max-w-full bg-white border rounded-2xl card-shadow pt-6 flex-1">
      <div className="absolute left-4 top-12 flex flex-row gap-2">
        <Button
          variant="primary"
          style="outline"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={() => scroll("right")}
          icon={ArrowRight2}
        />

        <Button
          variant="primary"
          style="outline"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={() => scroll("left")}
          icon={ArrowLeft2}
        />
      </div>

      <h3
        className="
          relative pr-7 leading-7 font-bold text-xl mb-3 text-primaryVar-500
          before:absolute before:right-4 before:top-1/2 before:-translate-y-1/2 before:h-4 before:w-1 before:rounded before:bg-primaryVar-500
        "
      >
        محتوای ویدیو
      </h3>

      <p className="font-semibold text-xs text-gray-500 pr-4">
        (در بخش هوم پیج فقط در قالب ویدیو قابل بارگزاری است)
      </p>

      <div className="my-6 h-px w-full bg-[repeating-linear-gradient(to_right,#D1D5DB_0_7px,transparent_7px_14px)]" />

      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto no-scrollbar pb-6 px-4 min-h-[280px]"
      >
        {isLoading
          ? Array.from({ length: 8 }).map((_, i) => (
              <VideoCarouselItemSkeleton key={i} />
            ))
          : video.map((item) => (
              <VideoCarouselItem
                key={item.uuid}
                video={item}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))
        }
      </div>
    </div>
  );
};